/**
 * Generic neutral silhouettes used as photo fallbacks.
 * Inline data-URI SVG → no network call, no copyright issue, no jersey.
 */

export const FEMALE_SILHOUETTE = "data:image/svg+xml;utf8," + encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 240" preserveAspectRatio="xMidYMid meet">
  <defs>
    <linearGradient id="g" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="#e9ecf3"/>
      <stop offset="100%" stop-color="#c8cfdb"/>
    </linearGradient>
  </defs>
  <rect width="200" height="240" fill="url(#g)"/>
  <g fill="#9aa3b8" stroke="none">
    <circle cx="100" cy="78" r="28"/>
    <path d="M58 200 C58 162, 78 138, 100 138 C122 138, 142 162, 142 200 L142 240 L58 240 Z"/>
  </g>
</svg>
`).replace(/\n/g, "").replace(/  +/g, " ");

export const MALE_SILHOUETTE = "data:image/svg+xml;utf8," + encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 240" preserveAspectRatio="xMidYMid meet">
  <defs>
    <linearGradient id="gm" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="#e9ecf3"/>
      <stop offset="100%" stop-color="#c8cfdb"/>
    </linearGradient>
  </defs>
  <rect width="200" height="240" fill="url(#gm)"/>
  <g fill="#9aa3b8" stroke="none">
    <circle cx="100" cy="76" r="30"/>
    <path d="M52 200 C52 158, 74 134, 100 134 C126 134, 148 158, 148 200 L148 240 L52 240 Z"/>
  </g>
</svg>
`).replace(/\n/g, "").replace(/  +/g, " ");

// Variante "dark" pour les fonds sombres (équipe pro, perfs wall, etc.)
// Silhouette gris foncé sur dégradé presque noir.
export const MALE_SILHOUETTE_DARK = "data:image/svg+xml;utf8," + encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 240" preserveAspectRatio="xMidYMid meet">
  <defs>
    <linearGradient id="gmd" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="#2a2438"/>
      <stop offset="100%" stop-color="#160d24"/>
    </linearGradient>
  </defs>
  <rect width="200" height="240" fill="url(#gmd)"/>
  <g fill="#4a4258" stroke="none">
    <circle cx="100" cy="76" r="30"/>
    <path d="M52 200 C52 158, 74 134, 100 134 C126 134, 148 158, 148 200 L148 240 L52 240 Z"/>
  </g>
</svg>
`).replace(/\n/g, "").replace(/  +/g, " ");
